import * as React from 'react';
import { Container, HiddenInput, IconBox, Label } from './styles.js';

/**
 * Simple Checkbox component supports any React.ReactChild as label
 * All props from React.HTMLAttributes<HTMLInputElement> are supported.
 */ const Checkbox = ({ className , style , accentColor , children , ...props })=>{
    return /*#__PURE__*/ React.createElement(Container, {
        className: className,
        style: style
    }, /*#__PURE__*/ React.createElement(HiddenInput, props), /*#__PURE__*/ React.createElement(IconBox, {
        accentColor: accentColor
    }), /*#__PURE__*/ React.createElement(Label, null, children));
};

export { Checkbox };
